import React from 'react';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import DOMPurify from 'dompurify';
import { RefinementListProps } from '@white-nl/instantsearch-components/dist/types/components';
import Check from '../../../ui/icons/classic/solid/Check';

export default function RefinementList({
  refinementList,
  refinementListSettings,
}: RefinementListProps) {
  const {
    className,
    classNames,
    translations,
    showMore,
    searchable,
  } = refinementListSettings;
  const {
    items,
    canToggleShowMore,
    canRefine,
    isShowingMore,
    isFromSearch,
    refine,
    toggleShowMore,
  } = refinementList;

  const rootClass = [
    'ais-RefinementList',
    classNames?.root,
    !canRefine ? 'ais-RefinementList--noRefinement' : '',
    !canRefine ? 'classNames?.noRefinementRoot' : '',
    className,
  ].filter(Boolean).join(' ');

  const noResultClass = [
    'ais-RefinementList-noResults',
    classNames?.noResults,
  ].filter(Boolean).join(' ');

  const listClass = [
    'ais-RefinementList-list',
    classNames?.list,
  ].filter(Boolean).join(' ');

  const showMoreClass = [
    'ais-RefinementList-showMore',
    classNames?.showMore,
    !canToggleShowMore ? 'ais-RefinementList-showMore--disabled' : '',
    !canToggleShowMore ? classNames?.disabledShowMore : '',
  ].filter(Boolean).join(' ');

  const noResults = searchable
    && isFromSearch
    && items.length === 0
    && translations?.noResultsText;

  return (
    <div className={rootClass}>
      {noResults ? (
        <div className={noResultClass}>
          {translations?.noResultsText}
        </div>
      ) : (
        <ul className={listClass}>
          {items.map((item) => {
            const itemClass = [
              'ais-RefinementList-item',
              classNames?.item,
              item.isRefined ? 'ais-RefinementList-item--selected' : '',
              item.isRefined ? classNames?.selectedItem : '',
            ].filter(Boolean).join(' ');

            const labelClass = [
              'ais-RefinementList-label',
              classNames?.label,
            ].filter(Boolean).join(' ');

            const inputClass = [
              'ais-RefinementList-checkbox',
              classNames?.checkbox,
            ].filter(Boolean).join(' ');

            const labelTextClass = [
              'ais-RefinementList-labelText',
              classNames?.labelText,
            ].filter(Boolean).join(' ');

            return (
              <li key={item.value} className={itemClass}>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className={labelClass}>
                  <span
                    className="flex items-center justify-center absolute top-[0.3125rem] right-0 w-5 h-5 border border-grey-700 rounded-sm bg-white transition-border duration-300 group-has-[:checked]/label:bg-grey-700 group-has-[:focus]/label:inset-ring group-has-[:focus]/label:inset-inset-ring-grey-700 group-hover/label:inset-ring group-hover/label:inset-inset-ring-grey-700"
                  >
                    <Check iconClass="w-3 text-white" />
                  </span>
                  <span
                    className={labelTextClass}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.label),
                    }}
                  />
                  <input
                    checked={item.isRefined}
                    className={inputClass}
                    type="checkbox"
                    value={item.value}
                    onChange={() => {
                      refine(item.value);
                    }}
                  />
                </label>
              </li>
            );
          })}
        </ul>
      )}
      {showMore && (
        <button
          className={showMoreClass}
          disabled={!canToggleShowMore}
          type="button"
          onClick={toggleShowMore}
        >
          {translations?.showMoreButtonText
            ? translations.showMoreButtonText({ isShowingMore })
            : ''}
        </button>
      )}
    </div>
  );
}
